export default {seo:{title:'Search for an event',description:null},title:'Search for an event',inputFilter:{quickSearch:'Quick search'}};